import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const ctaSection = document.getElementById('contato');
    ctaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/c58860c0de9290e106b8a55542714277/9b4b1ef2cc007d1768cc08949af53373.jpeg)',
          backgroundPosition: 'center 30%'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#4A1C40]/85 via-[#4A1C40]/75 to-[#4A1C40]/85"></div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <img 
            src="https://static.readdy.ai/image/c58860c0de9290e106b8a55542714277/073974e5b6d6dc4e6a4e834d20c0beaf.jpeg" 
            alt="Barbara Marcelino Claudino - Advocacia e Consultoria Jurídica"
            className="h-16 w-auto"
          />
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/barbaramarcelinoadv?igsh=NWFmeHR0bmQ0NmRr&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className={`w-10 h-10 flex items-center justify-center rounded-lg transition-all duration-300 whitespace-nowrap ${
                scrolled
                  ? 'bg-[#4A1C40] text-white hover:bg-[#5A2C50]'
                  : 'bg-white/20 text-white hover:bg-white/30 border border-white/40'
              }`}
              title="Instagram"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a
              href="https://wa.me/5532998566774?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-5 py-3 rounded-lg font-medium transition-all duration-300 whitespace-nowrap flex items-center gap-2 ${
                scrolled
                  ? 'bg-green-600 text-white hover:bg-green-700'
                  : 'bg-green-500/80 text-white hover:bg-green-500 border border-white/30'
              }`}
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp
            </a>
            <button 
              onClick={scrollToContact}
              className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 whitespace-nowrap ${
                scrolled 
                  ? 'bg-[#4A1C40] text-white hover:bg-[#5A2C50]' 
                  : 'bg-[#C9A961] text-[#4A1C40] hover:bg-[#D9B971]'
              }`}
            >
              Agendar Consulta
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Crimson Pro, serif' }}>
          Seus Direitos Trabalhistas <br />
          <span className="text-[#C9A961]">Merecem Ser Defendidos !</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto leading-relaxed font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Advocacia trabalhista comprometida com a justiça e a dignidade do trabalhador. 
          Atendimento humanizado e atuação técnica para proteger seus direitos.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={scrollToContact}
            className="px-8 py-4 bg-[#C9A961] text-[#4A1C40] rounded-lg font-semibold text-lg hover:bg-[#D9B971] transition-all duration-300 shadow-xl whitespace-nowrap"
          >
            Agende uma Consulta
          </button>
          <a 
            href="https://wa.me/5532998566774?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta" 
            target="_blank" 
            rel="noopener noreferrer"
            className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold text-lg hover:bg-white hover:text-[#4A1C40] transition-all duration-300 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WhatsApp
          </a>
          <a
            href="https://www.instagram.com/barbaramarcelinoadv?igsh=NWFmeHR0bmQ0NmRr&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold text-lg hover:bg-white hover:text-[#4A1C40] transition-all duration-300 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-instagram-line text-xl"></i>
            Instagram
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center bg-[#C9A961]/20 rounded-full mb-4">
              <i className="ri-shield-check-line text-3xl text-[#C9A961]"></i>
            </div>
            <strong className="text-lg mb-2">Atuação Ética</strong>
            <p className="text-white text-base font-medium">Compromisso com as normas da OAB</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center bg-[#C9A961]/20 rounded-full mb-4">
              <i className="ri-heart-line text-3xl text-[#C9A961]"></i>
            </div>
            <strong className="text-lg mb-2">Atendimento Humanizado</strong>
            <p className="text-white text-base font-medium">Acolhimento e respeito em cada caso</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center bg-[#C9A961]/20 rounded-full mb-4">
              <i className="ri-scales-3-line text-3xl text-[#C9A961]"></i>
            </div>
            <strong className="text-lg mb-2">Experiência Técnica</strong>
            <p className="text-white text-base font-medium">Conhecimento profundo da legislação</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}